import React from 'react';
import {
  Box,
  Container,
  Heading,
  Text,
  VStack,
  HStack,
  Icon,
} from '@chakra-ui/react';
import { motion } from 'framer-motion';
import { useAppData } from '../../store/dataStore';

const MotionBox = motion(Box);

const WebinarNextSteps = ({ data }) => {
  const { appData } = useAppData();
  const { studentsCount } = appData;

  // Safety check
  const componentData = data || {
    title: 'What Happens Next',
    subtitle: "After registering, you'll receive:",
    steps: []
  };

  return (
    <Box py={{ base: 16, md: 24 }} bg="white">
      <Container maxW="container.xl">
        <MotionBox
          textAlign="center"
          mb={12}
          initial={{ y: 20, opacity: 0 }}
          whileInView={{ y: 0, opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <Heading
            as="h2"
            fontSize={{ base: '2xl', md: '4xl' }}
            color="brand.700"
            fontFamily="heading"
            mb={4}
          >
            {componentData.title}
          </Heading>
          <Text fontSize={{ base: 'lg', md: 'xl' }} color="brand.500">
            {componentData.subtitle}
          </Text>
        </MotionBox>

        <VStack spacing={6} maxW="3xl" mx="auto">
          {componentData.steps.map((step, index) => (
            <MotionBox
              key={index}
              w="full"
              initial={{ x: -30, opacity: 0 }}
              whileInView={{ x: 0, opacity: 1 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1, duration: 0.5 }}
            >
              <HStack
                bg="brand.50"
                p={6}
                borderRadius="xl"
                spacing={4}
                align="start"
                _hover={{ bg: 'accent.silver' }}
                transition="all 0.3s"
              >
                <Icon
                  as={step.icon}
                  boxSize={8}
                  color="accent.green"
                  flexShrink={0}
                />
                <VStack align="start" spacing={1}>
                  <Text
                    fontSize={{ base: 'lg', md: 'xl' }}
                    fontWeight="600"
                    color="brand.700"
                  >
                    {step.title}
                  </Text>
                  <Text fontSize="md" color="brand.500">
                    {step.description}
                  </Text>
                </VStack>
              </HStack>
            </MotionBox>
          ))}
        </VStack>
      </Container>
    </Box>
  );
};

export default WebinarNextSteps;